import { Box, InputAdornment, MenuItem } from '@mui/material';
import DropDownAddValueCustom from 'src/components/drop-down-add-value/drop-down-add-value-custom';
import { RHFSelect, RHFTextField } from 'src/components/hook-form';

export default function ActivityThirdRow({
  icon,
  onTradeAdd,
  setTradeWorkTitles,
  // detail calculations
  showDetailFields,
  calculationofLaborCostInDetail,
  calculationofLaborHrsInDetail,
  // base calculations
  calculationofLabourHrs,
  showTradeWorkAndHourlyRate,
  tradeWorkTitles,
}) {
  return (
    <>
      {showDetailFields && (
        <RHFTextField
          type="number"
          name="number_of_workers"
          label="Number of Workers"
          onChange={(e) => {
            calculationofLaborHrsInDetail(e.target.value, 'number_of_workers');
          }}
        />
      )}
      {showTradeWorkAndHourlyRate && (
        <>
          <DropDownAddValueCustom
            name="trade_work_titles"
            label={`Trade / Work Titles (To Calculate Labor Hrly Rate)`}
            onClick={onTradeAdd}
            options={tradeWorkTitles}
            // reload={() => reloadProjectStageOptions()}
            // url={endpoints.risk_management.risk_register.identification.project_stages}
          />

          <RHFSelect
            native
            name="shift_rate_type"
            label="Shift Rate Type"
            InputLabelProps={{ shrink: true }}
          >
            {['Regular Time Rate', 'Over Time Rate', 'Double Time Rate'].map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </RHFSelect>
        </>
      )}

      <RHFTextField
        disabled={showTradeWorkAndHourlyRate}
        type="number"
        onChange={(e) => {
          if (!showDetailFields) {
            calculationofLabourHrs(e.target.value, 'labor_hourly_rate');
          } else {
            calculationofLaborCostInDetail(e.target.value, 'labor_hourly_rate');
          }
        }}
        name="labor_hourly_rate"
        label="Labor Hourly Rate"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Box component="span" sx={{ color: 'text.disabled' }}>
                {icon}
              </Box>
            </InputAdornment>
          ),
        }}
      />
    </>
  );
}
